import { useParams } from 'react-router-dom';
import { Formik, Form, FormikHelpers } from 'formik';
import { Modal, ModalFooter } from '@intellecteu/common-ui';
import { Params } from 'app/constants';
import { useEscapeKey, useNotifications } from 'app/utils';
import { useCreateIdentitiesDump } from 'data';

import s from './styles.module.scss';

type IdentitiesDumpModalProps = {
  onClose: () => void;
  validator?: string;
};

export const IdentitiesDumpModal = ({ onClose, validator }: IdentitiesDumpModalProps) => {
  const { onSuccessCreateIdentitiesDump } = useNotifications();
  const { validatorName } = useParams() as typeof Params;

  const { mutate: createIdentitiesDump, isLoading } = useCreateIdentitiesDump(validatorName ?? validator);

  useEscapeKey(isLoading ? null : onClose);

  const onCreateIdentitiesDump = async ({ setErrors }: FormikHelpers<any>) => {
    createIdentitiesDump(undefined, {
      onSuccess: (data) => {
        onSuccessCreateIdentitiesDump(data.secretName as string);
        onClose();
      },
      onError: (error) => {
        if (error?.status === 400 && error?.body?.fieldErrors) {
          setErrors(error?.body?.fieldErrors);
        }
      },
    });
  };

  return (
    <Modal onClose={onClose} title="Create identities dump" isLoading={isLoading}>
      <Formik<any> initialValues={{}} onSubmit={onCreateIdentitiesDump}>
        {() => (
          <Form>
            {/* <Field */}
            {/*   component={TextInput} */}
            {/*   type="password" */}
            {/*   id="password" */}
            {/*   name="password" */}
            {/*   label={`${Labels.VALIDATOR_WALLET_PASSWORD}*`} */}
            {/*   data-1p-ignore */}
            {/*   autoFocus */}
            {/* /> */}
            <ModalFooter
              onClose={onClose}
              submitText="Confirm"
              footerClassName={s.identitiesModalFooter}
              isLoading={isLoading}
            />
          </Form>
        )}
      </Formik>
    </Modal>
  );
};
